"use client";

import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Chat/StructuredCards/FitnessScoreCard";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

const DIMENSION_LABEL = {
  control: "Control",
  safety: "Safety",
  growth: "Growth",
} as const;

export interface FitnessScoreDimensionRowProps {
  label: keyof typeof DIMENSION_LABEL;
  score: number;
  delta: number;
}

export function FitnessScoreDimensionRow({
  label,
  score,
  delta,
}: FitnessScoreDimensionRowProps) {
  const isUp = delta > 0;
  const isDown = delta < 0;
  const badgeText = isUp ? `+${delta}` : isDown ? `${delta}` : "--";

  return (
    <div
      className="flex w-full items-center justify-between overflow-clip"
      data-testid={`score-row-${label}`}
    >
      <p className="body_medium_s text-content_primary">
        {I18n.t(DIMENSION_LABEL[label])}
      </p>
      <div className="flex items-center gap-2">
        <p className="body_medium_m text-content_accent4_primary">{score}</p>
        <div
          className={cn(
            "flex min-w-[26px] items-center overflow-clip rounded-1 py-0.5 pl-1.5 pr-[7px]",
            isUp && "bg-background_accent1_overlay10",
            isDown && "bg-background_accent2_overlay10",
            !isUp && !isDown && "bg-background_white_overlay10",
          )}
        >
          <p
            className={cn(
              "body_medium_xs leading-3",
              isUp && "text-content_accent1_primary",
              isDown && "text-content_accent2_primary",
              !isUp && !isDown && "text-content_tertiary",
            )}
          >
            {badgeText}
          </p>
        </div>
      </div>
    </div>
  );
}
